// eslint-disable-next-line
declare let globalThis: any

export const registerDTLayer = (): void => {
  if (globalThis.dataLayer) {
    globalThis.addEventListener('dtLayer', (e: CustomEvent) => {
      const { detail } = e
      if (globalThis && globalThis?.dataLayer) {
        globalThis?.dataLayer.push(detail)
      }
    })
  }
}

export const clickSuggestionItem = (data: string) => {
  globalThis.dispatchEvent(
    new CustomEvent('dtLayer', {
      detail: {
        event: 'click',
        component: 'search',
        action: 'click suggestion',
        search_term: data
      }
    })
  )
}

export const clickSuggestionListItem = (link: string) => {
  globalThis.dispatchEvent(
    new CustomEvent('dtLayer', {
      detail: {
        event: 'search_click',
        component: 'search',
        action: 'click suggestion',
        link_text: link
      }
    })
  )
}
